export const SET_AUDIO = 'AUDIO/SET_AUDIO';
export const PLAY_TRACK = 'AUDIO/PLAY_TRACK';
export const PAUSE_TRACK = 'AUDIO/PAUSE_TRACK';
export const STOP_TRACK = 'AUDIO/STOP_TRACK';
export const UPDATE_TIME = 'AUDIO/UPDATE_TIME';
export const SEEK_TRACK = 'AUDIO/SEEK_TRACK';
export const CLEAR = 'AUDIO/CLEAR';
export const SET_SLIDER = 'AUDIO/SET_SLIDER';

export const SET_PLAYLIST = 'AUDIO/SET_PLAYLIST';
export const CLEAR_PLAYLIST = 'AUDIO/CLEAR_PLAYLIST';

export const setSlider = payload => ({
    type: SET_SLIDER,
    payload
});

export const setAudio = payload => ({
    type: SET_AUDIO,
    payload
});

export const playTrack = payload => ({
    type: PLAY_TRACK,
    payload
});

export const pauseTrack = () => ({
    type: PAUSE_TRACK
});

export const stopTrack = () => ({
    type: STOP_TRACK
});

export const updateTime = (currentTime, duration) => ({
    type: UPDATE_TIME,
    payload: { currentTime, duration }
});

export const seekTrack = (time) => ({
    type: SEEK_TRACK,
    payload: time
}); 

export const clear = () => ({
    type: CLEAR
}); 

export const setPlaylist = payload => ({
    type: SET_PLAYLIST,
    payload
});

export const clearPlaylist = () => ({
    type: CLEAR_PLAYLIST
});

